<template>
  <div class="row selection-holder">
    <div class="col-12 p-0">
      <div class="col-12 d-flex main-container" id="selectionrow">
        <div class="panel selections">
          <div class="panel fund-details">
            <div>
              <h3 style="display: inline;">{{ fundDetails.policySelectionHeading }}</h3>
              <button class="btn-link" @click.prevent="$emit('scroll-to', 'Learn More')" >Learn&nbsp;more</button>
            </div>
            <div
              v-if="fundDetails.policySelectionText"
              v-html="fundDetails.policySelectionText"
              class="policy-selection-text"
            ></div>
          </div>
          <div v-for="(policy, index) in policies" :key="index" >
            <div :class="{'hide-now': policy.policyIndex == 0 && !showOptOut }" class="selection_items">
              <label :for="policy.value" class="policy-label">
                <input
                  type="radio"
                  name="policy"
                  :id="index"
                  :value="policy.policyIndex"
                  v-model="selectedPolicy"
                  @change="selectPolicy()"
                  class="policy-radio"
                />
                <span class="policies-label">{{ policy.policyTitle }}</span>
              </label>
              <div class="policy-content-holder">
                <div v-html="policy.policyText" class="policy-content"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--disclosure start-->
      <div class="panel disclosure main-container">
        <div class="disclosure_p d-flex">
          <h3>{{ disclosure.disclosureHeader }}</h3>
          <button
            id="showModalToolTip"
            aria-label="Disclosure Info"
            class="disclosure-opener tooltip-icon-holder p-0"
            @click="showModal"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <title v-if="!getHelpText">help icon</title>
              <g clip-path="url(#clip0_2030_3261)">
                <path
                  d="M10.6836 12.4477C10.3931 12.1572 9.92205 12.1567 9.63099 12.4477L4.5856 17.4931L4.5856 12.9741C4.5856 12.5625 4.25296 12.2298 3.84137 12.2298C3.42978 12.2298 3.09714 12.5625 3.09714 12.9741L3.09714 19.289C3.09661 19.3863 3.11661 19.4832 3.15451 19.5748C3.22977 19.7564 3.37504 19.9016 3.55662 19.9769C3.6482 20.0148 3.74452 20.0343 3.84242 20.0343L10.1573 20.0343C10.3626 20.0343 10.5489 19.9511 10.6836 19.8164C10.8184 19.6816 10.9015 19.4953 10.9015 19.29C10.9015 18.8784 10.5689 18.5458 10.1573 18.5458L5.63825 18.5458L10.6836 13.5004C10.9747 13.2093 10.9742 12.7383 10.6836 12.4477ZM17.8344 6.34969L17.8344 10.8688C17.8344 11.2803 18.167 11.613 18.5786 11.613C18.7839 11.613 18.9702 11.5298 19.1049 11.3951C19.2397 11.2603 19.3228 11.074 19.3228 10.8688L19.3228 4.55385C19.3233 4.45648 19.3033 4.35964 19.2654 4.26806C19.1902 4.08647 19.0449 3.94121 18.8633 3.86594C18.7718 3.82804 18.6754 3.80857 18.5775 3.80857H12.2626C11.851 3.80857 11.5184 4.14121 11.5184 4.5528C11.5184 4.96439 11.851 5.29703 12.2626 5.29703L16.7817 5.29703L11.7363 10.3424C11.4452 10.6335 11.4458 11.1045 11.7363 11.3951C12.0268 11.6856 12.4979 11.6861 12.789 11.3951L17.8344 6.34969Z"
                  fill="black"
                />
              </g>
              <defs>
                <clipPath id="clip0_2030_3261">
                  <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                </clipPath>
              </defs>
            </svg>
          </button>
        </div>
        <div :class="isDisclosureDisabled">
          <div :class="hasScrollBar ? 'overflow-auto' : ''" class="disclosure-container">
            <div v-html="disclosure.disclosureHeaderText"></div>
          </div>
        </div>
      </div>
      <!--end disclosure-->
      <div class="disclosure-button" v-if="disclosure.disclosureSubmitPolicyButtonLabel">
        <button @click="$emit('submit-selection', applyToAll)" :disabled="!hasAcceptedTerms">
          <span style="vertical-align: middle">{{ disclosure.disclosureSubmitPolicyButtonLabel }}&nbsp;&nbsp;</span>
          <svg
            class="icon"
            width="18"
            height="16"
            viewBox="0 0 18 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style="vertical-align: middle"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.8 0.799999L9.8 1.8L15.2 7.3H0V8.7H15.2L9.8 14.2L10.8 15.2L18 8L10.8 0.799999Z"
              fill="currentColor"
            />
          </svg>
        </button>
        <div aria-live="polite" aria-atomic="true">
          <span class="visually-hidden">
            {{ disclosure.disclosureSubmitPolicyButtonLabel }} {{ hasAcceptedTerms ? "enabled" : "disabled" }}
          </span>
        </div>
      </div>
    </div>
    <Modal :isModalVisible="isModalVisible" :disclosure="disclosure" v-show="isModalVisible" @close="closeModal" />
  </div>
</template>

<script>
import Modal from "../atoms/disclosureModal.vue";
export default {
  name: "Selection",
  props: {
    policies: Array,
    disclosure: Object,
    fundNames: Array,
    fundDetails: Object,
    lastSelectedFund: String,
    defaultToggleState: Boolean,
    showOptOut: Boolean,
  },

  components: { Modal },

  data() {
    return {
      selectedPolicy: this.lastSelectedFund,
      currentFundIndex: -1,
      applyToAll: true,
      isModalVisible: false,
      hasAcceptedTerms: this.showOptOut,
    };
  },

  watch: {
    defaultToggleState: function (defaultToggleState) {
      // console.log("defaultToggleState Updated=", defaultToggleState);
      this.applyToAll = defaultToggleState;
    },
    lastSelectedFund: function (lastSelectedFund) {
      // console.log("lastSelectedFund Updated=", lastSelectedFund);
      this.selectedPolicy = lastSelectedFund;
    },
    savedPoliciesLoaded: function (savedPoliciesLoaded) {
      //console.log("savedPoliciesLoaded Updated=", savedPoliciesLoaded);
      this.savedPoliciesLoaded = savedPoliciesLoaded;
      this.hasAcceptedTerms = true;
    },
  },

  methods: {
    showModal() {
      this.isModalVisible = true;
      document.body.classList.add("modal-open");
      const closeModalBtn = document.getElementById("closeModalBtn");
      setTimeout(() => {
        closeModalBtn.focus();
      }, 0);
    },

    closeModal() {
      this.isModalVisible = false;
      document.body.classList.remove("modal-open");
    },

    adjustToggleHeight() {
      const parent = this.$refs.toggle;
      const child = this.$refs.toggleText;
      if (parent && child) parent.style.height = child.offsetHeight + "px"; // Set parent's height based on child's
    },

    // Reset all policies when switching between single-fund and multi-fund policy selection
    resetPolicySelections() {
      this.selectedPolicy = "";
      this.currentFundIndex = -1;
      this.updateSelectedPolicy();
    },

    // When selecting a single-fund, always synch with the selected policy
    selectFund(index) {
      if (!this.applyToAll) {
        this.currentFundIndex = index;
        this.selectedPolicy = this.fundNames[this.currentFundIndex].selectedPolicy;
      }
      this.updateSelectedPolicy();
    },

    // When selecting a policy, apply it to all funds or to a single fund
    selectPolicy() {
      this.hasAcceptedTerms = true;
      if (this.applyToAll || (!this.applyToAll && this.currentFundIndex >= 0)) this.updateSelectedPolicy();
    },

    // Notify the parent component of the policy selections
    updateSelectedPolicy() {
      this.$emit("update-selected-policy", this.currentFundIndex, this.selectedPolicy);
    },    
  },
  computed: {
    // Aria text for Apply All toggle button
    liveRegionMessage() {
      return this.applyToAll
        ? "Multiple fund policy selection is enabled and all previous selections have been reset. Selected policy will now be applied to all funds."
        : "Multiple fund policy selection is disabled.";
    },

    // Returns true if all funds have policies selected
    isPolicySelected() {
      if (this.lastSelectedFund !== "") {
        this.hasAcceptedTerms = true;
      }
      return this.fundNames.length > 0 ? this.fundNames.every((fund) => fund.selectedPolicy != "") : false;
    },

    // Returns true if multiple funds
    isMultipleFunds() {
      return this.fundNames.length > 1;
    },

    // Returns true if disclosure is more than 500 characters
    hasScrollBar() {
      return this.disclosure.disclosureHeaderText.length > 500;
    },

    hasVotingPolicyLink() {
      return this.fundDetails.votingPolicyComparisonLabel && this.fundDetails.votingPolicyComparisonLink;
    },

    isDisclosureDisabled() {
      if (!this.isPolicySelected) {
        // this.hasAcceptedTerms = false;
        // return "disabled-tint";
        return "";
      }
    },

    getHelpText() {
      var disclosureHeaderHelp = "";
      if (this.disclosure.disclosureHeaderHelp)
        // Inline style workaround for css var not working for change color and font family
        disclosureHeaderHelp = `<p style="color:${this.disclosure.tooltipColor};margin:0; font-family:${this.disclosure.tooltipTypeStyle};">${this.disclosure.disclosureHeaderHelp}</p>`;
      return disclosureHeaderHelp;
    },

    disclosureHeaderTextClasses() {
      let scroll = "";
      let disabledScroll = "";

      if (this.hasScrollBar) {
        scroll = "scrollbar";
      }

      if (!this.isPolicySelected) {
        disabledScroll = "no-scroll";
      }

      return `${scroll} ${disabledScroll}`.trim();
    },
  },
  mounted() {
    this.adjustToggleHeight();
    window.addEventListener("resize", this.adjustToggleHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.adjustToggleHeight);
  },
};
</script>
<style lang="scss" scoped>
.d-flex {
  &.main-container {
    padding-top: 0px;
    margin-bottom: 30px;

    .panel {
      &.selections {
        width: 100%;
        // margin-top: 30px;
        h3 {
          margin-bottom: 20px;
        }
      }
      p {
        font-size: 14px;
      }
    }

    @include media-breakpoint-up(lg) {
      grid-template-areas: "funds selections";
      margin-bottom: 30px;
    }

    @include media-breakpoint-down(sm) {
      margin-bottom: 24px;
    }
  }
}

.panel.disclosure p {
  font-size: 14px;
}
.disclosure_p {
  padding-bottom: 16px;
  justify-content: space-between;  
  gap: 1rem;
  button {
      width: 25px !important;
  }
  @include media-breakpoint-up(sm) {
    justify-content: flex-start;
    padding-bottom: 24px;
  }
}

.disclosure-container {
  max-height: 300px;
  overflow: hidden scroll;
  padding: 10px;
  border: 1px solid rgba(194, 203, 208, 0.5);
  p {
    margin-top: 20px;
    font-size: 14px !important;
  }
  p,
  h4 {
    color: #333;
  }
  @include media-breakpoint-up(md) {
    max-height: 150px;
  }
}

.hide-now {
  display: none !important;
}

.selection-holder {
  font-family: var(--micrositeTypeStyle);
  background: var(--selection-background);
  // padding-bottom: 30px;
  padding-left: 30px;
  padding-right: 30px;

  @include media-breakpoint-up(lg) {
    // padding-bottom: 80px;
    padding-left: 0px;
    padding-right: 0px;
  }
}
.selection_items {
  margin: 24px 0 0;
}

.tooltip-icon-holder {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 2px;
}

.panel {
  &.funds {
    grid-row: auto;
    grid-column: auto;
    grid-area: funds;
    height: auto;
    padding: 20px;
    border: 1px solid var(--stroke);
    background: #fff;
    margin-bottom: 30px;

    @include media-breakpoint-up(lg) {
      padding: 0;
      border: none;
      box-shadow: none;
      background: transparent;
      margin-bottom: 0;
    }

    .funds-holder {
      @include media-breakpoint-up(lg) {
        background: #fff;
        border: 1px solid var(--stroke);
        padding: 30px;
      }

      .fund-details-intro {
        padding: 0;
        margin-bottom: 20px;
        color: var(--primaryText);
        font-size: 15px;
        line-height: 150%;
      }
    }

    .funds_div {
      padding: 0;
      margin: 0;
    }
  }
}

.no-scroll {
  pointer-events: none;
}

.disabled-tint {
  opacity: 0.6;
}

.panel {
  &.selections {
    grid-area: selections;
  }
}

.checkbox-text {
  margin-top: 30px;

  label {
    font-size: 15px;
    line-height: 150%;
    color: var(--primaryText);
  }
}

.check-box-holder {
  border-radius: 100%;
  background: var(--button);
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  flex-flow: column;
  justify-content: center;
}

.funds-content {
  background-color: $secondary-background;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  width: 100%;
  border-top: 1px solid var(--stroke);
  &:is(.singleFund) {
    background: var(--selection-background);
  }

  &.selected,
  &:hover {
    background: var(--selection-background);
  }

  div {
    background-color: transparent;
  }
}
.funds-content.selected {
  outline: 2px solid var(--button);
}

.funds {
  .fund-selected-grid {
    display: grid;
    grid-template-columns: 24px 1fr;
    column-gap: 20px;
    padding: 20px 10px 20px 10px;
    margin-bottom: 0;

    div {
      padding: 0;
      margin: 0;
    }
  }
}

.disclosure-button {
  margin: 30px 0 0;

  @include media-breakpoint-up(lg) {
    margin-left: 40px;
    margin-right: 40px;
  }
  @include media-breakpoint-down(sm) {
    margin-top: 24px;    
  }

  button {
    @include primary-btn();
    font-weight: 700;
    line-height: 150%;

    &:disabled {
      color: var(--disabled-button-text);
      background-color: var(--disabled-button);
      opacity: 0.9;
    }
  }
}

.disclosure-opener {
  // position: relative;
  // left: 10px;
  // bottom: 1px;
  svg {
    fill: var(--primaryText);
  }
}

.mock-radio {
  border-radius: 100%;
  border: 2px solid var(--button);
  display: block;
  width: 24px;
  height: 24px;
}

.selections {
  background-color: #fff;
  border: 1px solid var(--stroke);
  padding: 24px;
  .fund-details {
    padding-top: 0;
    // padding-bottom: 10px;
    h3 {
      margin-right: 16px;
    }
    .btn-link {
      color: #D5000A;
      padding: 0; 
      width: auto !important;     
    }
    a {
      font-size: 16px;
      font-weight: 400;
      line-height: 150%;
    }

    .policy-selection-text {
      padding-top: 0;
      padding-bottom: 20px;
      font-size: 16px;
      line-height: 150%;
      color: var(--primaryText);
    }
  }
  .policy-content-holder {
    // padding: 10px 0 0 0;
    margin-left: 40px;
    display: flex;
    flex-flow: column;
    row-gap: 10px;
    font-size: 16px;
    line-height: 150%;
    color: var(--primaryText);

    a {
      font-size: inherit;
      line-height: inherit;
    }

    @include media-breakpoint-down(sm) {
      margin-left: 32px;
    }
  }

  .policy-label {
    width: 100%;
    padding-bottom: 10px;
  }
  .policy-content {
    padding: 0;
  }
}

.selections::v-deep span {
  display: inline-block;
  margin-top: 10px;
}

.selections div::v-deep {
  // padding-top: 10px;
  // padding-bottom: 10px;
}
.selections::v-deep span p:last-child {
  margin-bottom: 0;
}
.selections::v-deep span {
  // margin-left: 30px;
  display: block;
}

.selections::v-deep span.policies-label {
  display: inline-block;
  width: calc(100% - 40px);
  margin-left: 0px;
  margin-top: 0;
  color: var(--primaryText);
}

.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
  padding-right: 10px;
  background-color: transparent !important;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.switch input:focus + .slider {
  // outline: 2px solid var(--button);
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: -2px;
  right: 0;
  bottom: 0;
  background-color: var(--switch-bg);
  // outline: 2px solid var(--switch-bg);
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 4px;
  top: 3px;
  background-color: #fff;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: var(--button);
}

input:focus + .slider {
  // box-shadow: 0 0 1px var(--button);
}

input:checked + .slider:before {
  -webkit-transform: translateX(25px);
  -ms-transform: translateX(25px);
  transform: translateX(25px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.multi-fund-para,
.toggle {
  padding: 0px !important;
  background: none !important;
  position: relative;
}

.toggle .toggleText {
  cursor: pointer;
  position: absolute;
  padding-left: 60px;
  top: 0px;
  color: var(--primaryText);
}

@include media-breakpoint-down(lg) {
  .selections::v-deep span.policies-label {
    display: inline-block;
    margin-left: 0;
    width: calc(100% - 40px);
    margin-top: 0;
    vertical-align: top;
  }
}

.info-icon {
  padding-left: 10px;
  padding-top: 7px;
}
#selectionrow {
  background-color: unset;
  padding-bottom: 0px;
}

.notice-panel {
  padding: 30px 40px 0;
  .notice {
    border-left: 6px solid var(--stroke);
    padding-left: 20px;

    h3 {
      // color: #333;
      // font-family: "Open Sans", "Arial", sans-serif;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 120%;

      svg {
        margin-right: 10px;
        fill: var(--primaryText);
      }
    }
    p {
      // color: #333;
      // font-family: "Arial", sans-serif;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      margin-bottom: 0;
    }
  }
  @include media-breakpoint-down(lg) {
    padding-left: 0;
    padding-right: 0;
  }
}

.funds p {
  font-size: 14px;
  line-height: 150%;
}

#checkbox-text {
  padding-top: 5px;
}

.funds {
  background-color: #fff;
  height: 60%;
  padding: 20px;
}

.scrollbar {
  padding: 7px;
  border: 1px solid rgba(194, 203, 208, 0.5);
}

.disclosure {
  margin-top: 0px;
  padding-top: 30px;
  border: 1px solid var(--stroke);
  padding: 24px;
  font-size: 12px;
  line-height: 150%;
  color: var(--primaryText);

  @include media-breakpoint-down(sm) {
    padding: 16px;
  }

  p::v-deep {
    font-size: inherit;
    line-height: inherit;
  }

  .required-info {
    font-size: 15px;
    line-height: 150%;
    margin-top: 30px;
  }

  h3 {
    display: flex;
    align-items: center;
    flex-direction: row;
    column-gap: 5px;
    font-size: 18px;
    line-height: 150%;
    color: var(--primaryText);
    font-weight: 700;
    margin: 0;

    svg {
      fill: var(--primaryText);
    }
  }

  .overflow-auto {
    max-height: 250px;
    scrollbar-color: var(--dark);
    padding: 10px;
    @include media-breakpoint-up(md) {
      max-height: 150px;
    }
    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-thumb {
      background: color-mix(in srgb, var(--dark) 50%, transparent);
      border-radius: 8px;
    }
  }

  @include media-breakpoint-up(lg) {
    margin-left: 40px;
    margin-right: 40px;
  }
}
.policy-radio {
  vertical-align: top;
  margin-top: 0px !important;
  margin-right: 16px !important;
  @include media-breakpoint-down(sm) {
    margin-right: 8px !important;
  }
}

@media (forced-colors: active) {
  .check-box-holder,
  input[type="radio"]:checked::before {
    forced-color-adjust: none;
  }

  .disclosure .overflow-auto::-webkit-scrollbar,
  .disclosure .overflow-auto::-webkit-scrollbar-thumb {
    forced-color-adjust: none;
  }

  .disclosure .overflow-auto::-moz-scrollbar,
  .disclosure .overflow-auto::-moz-scrollbar-thumb {
    forced-color-adjust: none;
  }
}
@media (forced-colors: active) and (prefers-color-scheme: dark) {
  .disclosure h3 svg {
    fill: #fff;
  }
  .disclosure .overflow-auto {
    scrollbar-color: #fff;

    &::-webkit-scrollbar-thumb {
      background: color-mix(in srgb, #fff 50%, transparent);
      border-radius: 8px;
    }
  }
}

 @include media-breakpoint-down(sm) {
  .selections {
    background-color: #fff !important;
    border: none !important;
    padding: 0px !important;
  }
  .selection_items {
    background-color: #fff !important;
    border: 1px solid var(--stroke) !important;
    padding: 16px !important;
  }
  .selection-holder {
    padding: 0px 24px !important;
  }
  .fund-details {
    h3 {
      font-size: 24px !important;
    }
  }
  .selections label,
  .policy-content-holder, .disclosure h3,.panel p {
    font-size: 16px !important;
  }
  .disclosure-button button{
    width:100% !important;
    font-size:16px !important;
    height: auto !important;
  }  
}
</style>
